export const MAP_CONFIGURATION = {
  zoom: 15,
  scrollZoom: false,
  dragPan: false,
  dragRotate: false,
  touchZoom: false,
  doubleClickZoom: false,
};
